import type { SVGProps } from "react";

const SvgPaypalSmallLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="57.1 28.7 397.7 455.1"
    width="1em"
    height="1em"
    style={{
      background: "#fff",
    }}
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="#253B80"
        d="M218.441 166.182c.762-4.9 3.9-8.9 8.125-10.916a14.56 14.56 0 0 1 6.317-1.433h89.548c10.854 0 20.986.71 30.23 2.205 2.644.422 5.21.908 7.716 1.459 2.49.56 4.921 1.18 7.276 1.869 1.172.348 2.33.71 3.463 1.072 4.55 1.507 11.171 5.744 12.672 3.28 4.589-29.246-.035-49.156-15.85-67.188-17.43-19.853-48.896-28.349-89.158-28.349H161.897c-8.224 0-15.239 5.98-16.512 14.119L96.703 390.892c-.96 6.105 3.75 11.616 9.904 11.616h74.228l18.118-114.95z"
      />
      <path
        fill="#179BD7"
        d="M382.58 170.57c-15.411 79.142-68.147 106.483-135.498 106.483h-34.294c-8.237 0-15.178 5.978-16.461 14.103l-17.555 111.353-4.973 31.562c-.835 5.334 3.277 10.144 8.66 10.144h60.822c7.203 0 13.318-5.235 14.454-12.336l.598-3.091 11.45-72.672.736-3.988a14.63 14.63 0 0 1 14.454-12.361h9.098c58.928 0 105.056-23.923 118.54-93.159 5.633-28.921 2.718-53.072-12.185-70.054-4.512-5.123-10.109-9.373-16.65-12.835q-.52 3.344-1.196 6.85"
      />
      <path
        fill="#222D65"
        d="M367.653 157.288a120 120 0 0 0-7.277-1.866 139 139 0 0 0-7.715-1.462c-9.245-1.495-19.376-2.205-30.23-2.205h-91.613c-2.253 0-4.397.512-6.317 1.434-4.224 2.032-7.363 6.032-8.125 10.928l-19.488 123.44-.563 3.6c1.286-8.125 8.227-14.106 16.46-14.106h34.295c67.35 0 120.087-27.354 135.501-106.48.46-2.342.848-4.62 1.197-6.851-3.901-2.07-8.125-3.84-12.672-5.347a113 113 0 0 0-3.453-1.085"
      />
    </g>
  </svg>
);
export default SvgPaypalSmallLogo;
